import { ALTO_COLORS } from './alto';
import { FUZE_HEALTH_COLORS } from './fuzehealth';
import { FUZERX_COLORS } from './fuzerx';

export type ColorTokens = typeof ALTO_COLORS | typeof FUZE_HEALTH_COLORS | typeof FUZERX_COLORS;

// Internal mutable store, defaults to alto colors
let COLORS: ColorTokens = ALTO_COLORS;

// Called by the web ThemeProvider to swap brands at runtime
export function setColors(colors: ColorTokens) {
  COLORS = colors;
}

export type COLORS_VALUES = ColorTokens[keyof ColorTokens];
export type TEXT_COLORS_VALUES = ColorTokens['TEXT_COLORS'][keyof ColorTokens['TEXT_COLORS']];
export type BORDER_COLORS_VALUES = ColorTokens['BORDER_COLORS'][keyof ColorTokens['BORDER_COLORS']];
export type BACKGROUND_COLORS_VALUES = ColorTokens['BACKGROUND_COLORS'][keyof ColorTokens['BACKGROUND_COLORS']];
export type PALETTE_COLOR_VALUES =
  ColorTokens['PALETTE'][keyof ColorTokens['PALETTE']][keyof ColorTokens['PALETTE'][keyof ColorTokens['PALETTE']]];
export { COLORS, ALTO_COLORS, FUZE_HEALTH_COLORS, FUZERX_COLORS };
